import React, { useEffect, useRef, useState } from 'react'
import { UIProperties } from '../../cvp-webgames-core/Components/ui/UIProperties';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { TextHtmlTagType, generalAudioCaching, getGlobalTextSizeStyle, parseDynamicHtml } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import Button2 from '../general/button2';
import "./mixed-media.css"
import PopUp2 from '../general/pop-up2';
import { constants } from '../../misc/constants';
import { VideoSegmentItem, SingleVideoSegmentItem } from '../../cvp-webgames-core/VideoSegment/VideoSegmentItem';
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../cvp-webgames-core/pre-caching/pre-cache-item';
import MentorUI from './mentor-ui';
import MediaControlsUI from './media-controls-ui';

class MixedMediaUICaching extends VideoSegmentItem {
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: 'Mentor Video 1',
				src: process.env.PUBLIC_URL + '/assets/videos/mentor/loopVideo.mp4',
				chapterIds: [
					'Loop 1'
				]
			},
			{
				key: 'Scenario 1 Mentor Video 1',
				src: process.env.PUBLIC_URL + '/assets/videos/mentor/talkVideo.mp4',
				chapterIds: [
					'Talk 1'
				]
			}
		];
	}
}

export const mixedMediaUICaching = new MixedMediaUICaching();

class MixedMediaUIImgCaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'back-10',
				src: process.env.PUBLIC_URL + '/assets/images/vid-controller/replay-last-10.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'forward-10',
				src: process.env.PUBLIC_URL + '/assets/images/vid-controller/skip-next-10.svg'
			}
		];
	}
}

export const mixedMediaUIImgCaching = new MixedMediaUIImgCaching();
const mediaId = Tools.generateGuid()

const MixedMediaUI = (props: UIProperties<MixedMediaUIConfig>) => {
	const [isInit, setIsInit] = useState(false);
	useEffect(() => {
		if(!isInit) {
			setIsInit(true);
			const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.music_marimba_chord_01).src;
			Tools.playOneShotSound(url);
		}
	}, []);

	return (
		<div className="modal-disable-select mixed-media-ui black-overlay" style={{
		}}>
			<div aria-label='mixed media' className={`mixed-media-ui-inner center-element ${constants.mainContent508Id}`}>
				<PopUp2
				titleLeft= {constants.projectTitle}
				titleRight= {props.parameters.title}
				subtitleRight= {props.parameters.subtitle}
				onRenderContent={() => {
					return (
					<div className='mixed-media-ui-inner-content'>
						<div className='mixed-media-ui-content'>
							<div className='mixed-media-ui-content-container main-content-inner'>
								<div className='mixed-media-ui-container-container'>
									<div className='mixed-media-ui-content-container-mentor'>
										<MentorUI mediaId={mediaId} talkingVideoSrc={props.parameters.talkingVideoSrc} chapterId={props.parameters.talkingVideoChapterId}></MentorUI>
									</div>
									<div style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='mixed-media-ui-content-container-inner default-text black-text default-text text-manual-edit-p' dangerouslySetInnerHTML={{ __html: parseDynamicHtml(props.parameters.htmlData) }}>
									</div>
								</div>
							</div>
						</div>
						<div style={{
							width: '990px',
							height: '100px',
							position: 'relative',
							left: '50%',
							transform: 'translatex(-50%)'
						}}>
							<MediaControlsUI mediaId={mediaId}></MediaControlsUI>
						</div>
						{/* <div className='mixed-media-ui-audio'>
							<div className='mixed-media-ui-content-container main-content-inner'>
								<div className='controls-container'>
									<button onClick={togglePlay} className='default-text mixed-media-bttn'>{isPlaying ? "Pause" : "Play"}</button>
									<progress className='mixed-media-bar' value={progress} max="100"></progress>
									<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='default-text mixed-media-time black-text'>{currentTime} / {finalTime}</p>
									<button onClick={skipBack} className='default-text mixed-media-bttnBack'>{<img src={mixedMediaUIImgCaching.getItemByKey('back-10').src}></img>}</button>
									<button onClick={skipForward} className='default-text mixed-media-bttnForward'>{<img src={mixedMediaUIImgCaching.getItemByKey('forward-10').src}></img>}</button>
								</div>
							</div>
						</div> */}
						<div>
							<div className='mixed-media-ui-content-confirm-bttn-container center-element-horizontal'>
								<Button2 width= '100%'
									hoverBgColor={constants.design.hoverColor2}
									height= '100%'
									idFor508='mixed-media-content-top'
									onClick= {props.parameters.onContinueClicked}
									onRenderContent= {() => {
										return (
											<div>
												<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='small-text mixed-media-ui-content-btn-confirm-text center-element-vertical default-text text-manual-edit-p'>{props.parameters.okButton}</p>
											</div>
										)
									}}
									isSelected= {false}
									ariaLabel= {props.parameters.okButton}></Button2>
							</div>
						</div>
					</div>
					);
				}}></PopUp2>
			</div>
		</div>
	);

};

export interface MixedMediaUIConfig extends BaseConfig {
	title: string;
	subtitle: string;
	htmlData: string;
	okButton: string;
	talkingVideoSrc: string;
	talkingVideoChapterId: string;
	onContinueClicked?: () => void;
}

export default MixedMediaUI;